module.exports = __webpack_public_path__ + "static/img/f571895ae7a5f38211dbc32638397b29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品与服务-改(1)_44.png
// module id = jaJs
// module chunks = 1